const A = "00000000-0000-0000-0000-000000000000";
function n(t) {
  return !!(t && t.length >= 36 && t.match(/^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i) && t !== A);
}
export {
  A as uuidNil,
  n as validUUID
};
